import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import { initializeApiClient } from "@crm/api";
import App from "./App";
import "./index.css";

// Initialize API client
const API_BASE_URL = import.meta.env.VITE_API_URL || "http://localhost:8000";

initializeApiClient({
  baseURL: API_BASE_URL,
  onAuthError: () => {
    // Redirect to login on auth error
    window.location.href = "/login";
  },
});

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster position="top-right" richColors closeButton />
    </QueryClientProvider>
  </StrictMode>
);
